import { useMyTasksQuery } from '@common/cache';
import { TASK_PRIORITY } from '@common/types';
import { ITaskTableEntry } from '@views/pages/Worklist/common/TaskTable/hooks';
import { useMyWorklistFilterStore } from 'views/pages/Worklist/MyWorklist/store/filter.store.ts';
import { useDrawerStore, useMyWorklistStore } from 'store';

export const useInProgressTasks = () => {
  const {
    filters,
    setFilters: handleFilterChange,
    clearStore,
    isInitialFilters,
  } = useMyWorklistFilterStore();
  const clearPersistedFilters = useMyWorklistStore(state => state.clearStore);
  const { setDrawerOpen, setTaskId, taskId } = useDrawerStore(state => state);

  const handleFullReset = () => {
    clearStore();
    clearPersistedFilters();
  };

  const {
    data = {
      count: 0,
      tasks: [],
    },
    isFetching,
    isRefetching,
  } = useMyTasksQuery({ ...filters, statuses: ['In progress'] });

  const entries: ITaskTableEntry[] = data.tasks.map(task => ({
    ...task,
    priority: task.priority as TASK_PRIORITY,
  }));

  const handleOpenTaskDetails = (id: string) => {
    setTaskId(id);
    setDrawerOpen(true);
  };

  return {
    selectedTaskId: taskId,
    handleCloseDrawer: () => setDrawerOpen(false),
    handleOpenTaskDetails,
    entries,
    totalCount: data.count,
    filters,
    isLoading: isFetching || isRefetching,
    handleFilterChange,
    isInitialFilters,
    handleResetFilters: handleFullReset,
  };
};
